// Geometry of the 40 Yawgoo master artwork, measured in source pixels.
export const logoArtwork = {
  src: 'https://cdn.magicpatterns.com/uploads/nUDiw75BcQQfNuS2UkFNpm/Screenshot_2026-10-04_at_3.00.27_PM.png',
  alt: '40 Yawgoo Consulting',
  width: 1360,
  height: 1112,
  mark: { cx: 655, cy: 410, r: 233 },
  /** Tight bounds of the lockup artwork, excluding the white field. */
  bounds: { x1: 130, y1: 172, x2: 1185, y2: 968 },
};
